// ── Design Studio — general availability (2026-10-01) ───────────────────────────────────────
// Was a restricted-rollout allowlist (only Tester 01 could see/open Design Studio; purchasing
// was hard-disabled backend-side). Opened to every business account after go-live-check
// confirmed live Razorpay keys, a correctly-signed main checkout webhook, a correctly-signed
// PRO webhook, and a valid pinned ₹599/mo plan (see designStudioRoutes.js's SUBSCRIPTIONS_OPEN).
// The real gate is backend-side PRO status (DesignStudioGate.jsx shows the studio or the ₹599/mo
// paywall accordingly) — this function only decides who can see the nav tab and reach the route
// at all, which is now simply "any real, logged-in store."
export function dsAllowed(storeId) {
  return !!storeId;
}
